import React from "react";
import "components/General/Form/Form.css";

const CustomRadio = (props) => {
  return (
    <div className="form-group">
      <input
        type="radio"
        id={props.value}
        name={props.name}
        value={props.value}
        defaultChecked={props.defaultChecked}
        onChange={props.handleChange}
        checked={props.isChecked}
        style={{cursor:"pointer"}}
      />
      <label style={{cursor:"pointer"}} htmlFor={props.value}>&nbsp;&nbsp;{props.text}</label>
      <div className="invalid-feedback" style={{ display: "block" }}>
        {props.error}
      </div>
    </div>
  );
};

export default CustomRadio;
